import { IonActionSheet, IonRouterLink, IonSpinner, IonApp, IonContent, IonPage, IonHeader, IonTitle, IonButtons, IonModal, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { trashOutline, copyOutline, banOutline, thumbsUpOutline, alertCircleOutline, close, arrowRedoOutline, thumbsUpSharp, thumbsDownSharp, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState }  from 'react';
import { Dialog, ConfirmResult } from '@capacitor/dialog';

import { NotiInfo } from "../data/item";
import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";

import '../pages/Main.css'; 
import '../pages/ChatMsg.css';

interface NotiProp {
    noti: NotiInfo;
}

const Noti : React.FC<NotiProp> = ({ noti }) => {
    
    const router = useIonRouter();

    // go to noti path
    const gotoPath = async () => {
        // mark the notification as read
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            noti: noti.id
        }

        var server = new NServer();
        await server.sendForm("nc_noti_read", state);
        
        // just move to path
        router.push(noti.path, "forward", "push");
    }

    return (
        <IonItem className={ noti.read==1 ? "noti-read" : "noti-unread" } lines="none" color="none" onClick={gotoPath}>
            <IonAvatar className="comment-avt" slot="start">
                <img src={noti.avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <div className="ion-activatable ripple-parent">
                <div className="noti-text"><b>{noti.highlight}</b>{ noti.title }</div>
                <small><IonText color="medium">{ noti.time }</IonText></small>
                <IonRippleEffect></IonRippleEffect>
            </div>
        </IonItem>
    );
};
  
export default Noti;